<script>
  import { page } from '@inertiajs/svelte';
</script>

<footer class="footer">
  <div class="footer-content">
    <div class="footer-brand">
      <span class="brand">MASET</span>
      <span class="tagline">Pocket Inventory</span>
    </div>
    <div class="footer-copy">
      <span>&copy; {new Date().getFullYear()} Maset. All rights reserved.</span>
      {#if $page.props.app_version}
        <span class="footer-version">{$page.props.app_version}</span>
      {/if}
    </div>
  </div>
</footer>

<style>
.footer {
  background: #111;
  color: #fff;
  padding: 3.5rem 0 2rem 0;
  border-top: 1px solid #222;
}
.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2.5rem;
}
.footer-brand {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.brand {
  font-weight: 700;
  font-size: 1.5rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}
.tagline {
  font-size: 0.92rem;
  color: #e5e7eb;
  letter-spacing: 0.01em;
}
.footer-copy {
  font-size: 0.95rem;
  color: #e5e7eb;
  display: flex;
  gap: 1.5rem;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}
.footer-version {
  font-size: 0.95rem;
  color: #b6bbc7;
}
@media (max-width: 640px) {
  .footer-content {
    align-items: center;
  }
  .footer-brand {
    align-items: center;
  }
}
</style> 